const translations = {
    positionLabel: 'Position {{number}}'
};

export default translations;
